import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Settings, MessageSquareText, Clock, Lightbulb, Sparkles, LogOut, Download, BarChart3, Calculator, Zap } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const Sidebar = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  
  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/insights-actions', icon: Zap, label: 'Insights & Actions' },
    { path: '/insights', icon: Sparkles, label: 'Insights' },
    { path: '/period-analysis', icon: BarChart3, label: 'Trend Analysis' },
    { path: '/recommendations', icon: Lightbulb, label: 'Recommendations' },
    { path: '/scenario-modeling', icon: Calculator, label: 'Scenario Planner' },
    { path: '/chat', icon: MessageSquareText, label: 'AI Chat' },
    { path: '/export', icon: Download, label: 'Export Center' },
    { path: '/settings', icon: Settings, label: 'Settings' }
  ];

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/');
  };

  return (
    <div className="sidebar w-64 flex flex-col" data-testid="sidebar">
      <div className="p-6 flex-1">
        {/* OvertimeIQ Logo */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center relative">
            <Clock className="text-white" size={20} />
            <div className="absolute -right-0.5 -bottom-0.5 flex gap-px">
              <div className="w-1 h-2 bg-[#FF8C42] rounded-sm"></div>
              <div className="w-1 h-3 bg-[#2E5C8A] rounded-sm"></div>
              <div className="w-1 h-2.5 bg-[#4CAF93] rounded-sm"></div>
            </div>
          </div>
          <div>
            <h1 className="text-lg font-bold text-[#1e3a5f]">
              Overtime<span className="text-[#2E5C8A]">IQ</span>
            </h1>
            <p className="text-xs text-muted-foreground">Premium Pay Analytics</p>
          </div>
        </div>

        <nav className="space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon size={20} />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
      
      {/* Logout button at bottom */}
      <div className="p-6 pt-0">
        <button
          onClick={handleLogout}
          className="nav-item w-full text-slate-500 hover:text-red-600 hover:bg-red-50"
          data-testid="nav-logout"
        >
          <LogOut size={20} />
          <span className="font-medium">Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;